export default __webpack_public_path__ + "static/media/non-seq-instruction.d78e61093545ee0bd5fd7fd769b7ac33.svg";